<template>
	<div>
		<div v-if="loading">
			<div class="loader full-page">
				<div class="loader-container">
					<img src="/images/spinner.svg" class="fa fa-spin spinner">
				</div>
			</div>
		</div>
		<div v-else>
			<div class="unauth-form">
				<div class="unauth-form-container">
					<login-form v-model="form" :action="onSubmit"></login-form>
				</div>
			</div>
			<div class="unauth-decor">
				<div class="logo">
					<img v-if="whiteLabelAccount && whiteLabelAccount.icon_url" :src="whiteLabelAccount.icon_url" :alt="whiteLabelAccount.company"/>
					<span v-else class="fak fa-gravity-fox"></span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

import { mapGetters } from 'vuex';
import { AuthMixin } from '@/mixins';
import LoginForm from './forms/LoginForm';
import getSubdomain from '@/utils/get-subdomain';

export default {

	name: 'LoginPage',

	mixins: [AuthMixin],

	data() {
		return {
			loading: true,
			form: {},
		};
	},

	computed: mapGetters(['whiteLabelAccount', 'hasIntended', 'intendedRoute']),

	beforeRouteEnter (to, from, next) {
		next(vm => {
			vm.$root.$emit('set-default-colors');
		})
	},

	mounted() {
		this.loading = true;
		(async () => {
			try {
				const subdomain = getSubdomain();
				if (subdomain) {
					const account = await this.$store.dispatch('loadWhiteLabelAccount', subdomain);
					console.log('acct', account);
					if (account) {
						this.$root.$emit('colors', account);
					}
				}
				else
				{
					this.$root.$emit('set-default-colors');
				}
			} catch(e) {}
			this.loading = false;
		})();
	},

	methods: {

		async onSubmit() {
			try {
				await this.$api.get('/sanctum/csrf-cookie');
			} catch(e) {
				this.$store.dispatch('errorToast', 'Unexpected error encountered');
				return;
			}

			await this.onSubmitLogin(this.form);

			this.$store.dispatch('goIntended');
		},

	},

	components: {
		LoginForm,
	},

};

</script>
